import { Sort } from '@angular/material/sort';

const DESCENDING_PREFIX = '-';

export function parseSortParam(value: unknown): Sort | undefined {
	if (typeof value !== 'string' || !value) {
		return undefined;
	}

	const isDescending = value.startsWith(DESCENDING_PREFIX);
	const active = isDescending ? value.slice(DESCENDING_PREFIX.length) : value;

	return active ? { active, direction: isDescending ? 'desc' : 'asc' } : undefined;
}

export function serializeSortParam(sort: Sort | undefined): string | null {
	if (!sort?.active || !sort.direction) {
		return null;
	}

	return `${sort.direction === 'desc' ? DESCENDING_PREFIX : ''}${sort.active}`;
}

export function isSameSort(a: Sort | undefined, b: Sort | undefined): boolean {
	return a?.active === b?.active && a?.direction === b?.direction;
}
